import {connect} from 'react-redux';
import React from 'react';
import {IntlProvider} from 'react-intl';
import * as i18n from '../i18n/index';
import {selectors} from '../Redux/index';

//addLocaleData([...en, ...de]);

const CustomIntlProvider = (props) => {
    const messages = i18n[props.locale];

    return <IntlProvider locale={props.locale} messages={messages} key={props.locale}>
        {props.children}
    </IntlProvider>;
};

// This function will map the current redux state to the props for the component that it is "connected" to.
// When the state of the redux store changes, this function will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
function mapStateToProps(state) {
    const locale = selectors.UI.Locale.getLocale(state);

    return {
        locale: locale,
    };
}

export default connect(mapStateToProps)(CustomIntlProvider);